/**
 * THE REVIT ADD-IN'S RETURN TRIP (PRD-553, ruled 2026-10-13).
 *
 * Reached only past the auth gate: the person is signed in here, MFA
 * and all, by the web door's own flow. This screen's whole job is to
 * hand the current ID token to the add-in's loopback listener and say
 * so. No auth code lives in the add-in; nothing is stored here; the
 * token travels in a URL fragment, so no server and no log ever sees it.
 */
import { useEffect, useState } from 'react';
import { DoorCard, Notice, Stack, Text } from '../../../strata';
import { loopbackCallbackUrl, parseAddinTrip } from '../host';
import { idTokenOf, type User } from '../session';
import { Brand } from './Brand';

const MALFORMED = 'This link did not come from the Revit add-in. Use Sign in from the add-in again.';

export function AddinCallback({ user }: { user: User }) {
  const trip = parseAddinTrip(window.location.search);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (trip === null) return;
    idTokenOf(user).then(
      (token) => window.location.replace(loopbackCallbackUrl(trip, token)),
      () => setFailed(true),
    );
  }, []);

  return (
    <DoorCard>
      <Stack direction="column" gap="xl">
        <Brand />
        {trip === null ? (
          <Notice kind="error">{MALFORMED}</Notice>
        ) : failed ? (
          <Notice kind="error">Could not read your session. Sign in from the add-in again.</Notice>
        ) : (
          <Text tone="secondary">Returning to Revit&hellip;</Text>
        )}
      </Stack>
    </DoorCard>
  );
}
